const styles = theme => ({
  root: {
    width: "100%",
    overflowX: "auto",
    WebkitOverflowScrolling: "touch"
  },
  name: {
    display: "flex",
    alignItems: "center",
    textAlign: "left"
  },
  nameValue: {
    marginLeft: "10px",
    padding: "10px"
  },
  addInput: {
    display: "flex",
    alignItems: "flex-end"
  },
  table: {
    minWidth: 700,
    tableLayout: "fixed",
    [theme.breakpoints.down("sm")]: {
      minWidth: 640
    }
  },
  columnName: {
    width: "28%",
    [theme.breakpoints.down("sm")]: {
      width: "30%"
    }
  },
  columnType: {
    width: "14%",
    [theme.breakpoints.down("sm")]: {
      width: "20%"
    }
  },
  columnValue: {
    width: "58%",
    whiteSpace: "normal",
    wordBreak: "break-word",
    minWidth: 220,
    [theme.breakpoints.down("sm")]: {
      width: "50%",
      minWidth: 0
    }
  },
  columnWidthInput: {
    width: "100%",
    textAlign: "left"
  },
  border: {
    borderRight: "1px solid #ccc"
  },
  align: {
    padding: "5px",
    textAlign: "center"
  },
  valueCell: {
    padding: "5px",
    textAlign: "left",
    verticalAlign: "middle"
  },
  valueNumber: {
    width: 80,
    "& input": {
      textAlign: "right"
    }
  },
  valueAmount: {
    width: 140,
    "& input": {
      textAlign: "right"
    }
  },
  valueText: {
    width: 280,
    maxWidth: "100%"
  },
  valueFlexible: {
    width: "100%",
    maxWidth: "100%"
  },
  formControl: {
    margin: "10px"
  },
  buttonSave: {
    flex: 1,
    display: "flex",
    alignItems: "end",
    justifyContent: "flex-end",
    marginTop: "30px"
  },
  expansionPanel: {
    boxShadow: "none"
  },
  expansionPanelText: {
    padding: "0 5px",
    maxHeight: 60
  },
  button: {
    margin: 4
  }
});
export default styles;
